import { EntityChildEditModal } from '@/pages/admin/shared/entity-management/EntityChildEditModal';

type EditSectorModalProps = {
	isOpen: boolean;
	onClose: () => void;
	departmentName: string;
	initialSectorName: string;
	onSave: (name: string) => void;
};

export const EditSectorModal = ({
	isOpen,
	onClose,
	departmentName,
	initialSectorName,
	onSave,
}: EditSectorModalProps) => {
	return (
		<EntityChildEditModal
			isOpen={isOpen}
			onClose={onClose}
			title="Editar Setor"
			description="Altere o nome do setor vinculado ao departamento."
			parentLabel="DEPARTAMENTO"
			parentName={departmentName}
			childLabel="NOME DO SETOR"
			childPlaceholder="Ex: Recrutamento"
			submitText="Salvar alterações"
			inputId="edit-modal-sector-name"
			initialChildName={initialSectorName}
			onSave={onSave}
		/>
	);
};
